<div class="modal-wrapper">
  <div class="modal-header">
    <h2 class="h6_500 modal-title" mat-dialog-title>
      {{ title | translate }}
    </h2>
    <button mat-icon-button class="modal-close-button" (click)="onEventClose()" aria-label="Close" matRipple="false">
      <mat-icon fontSet="material-icons-outlined">close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="modal-content">
    <div class="modal-form">
      <mat-form-field appearance="outline" class="single-select-input-field" [floatLabel]="'always'">
        <mat-label>{{ inputLabel | translate }}</mat-label>
        <mat-select [value]="selectedOptions" multiple (selectionChange)="onOptionSelected($event.value)">
          <mat-option *ngFor="let option of options" [value]="option">
            {{ getDisplayValue(option) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-actions">
    <common-buttons-outlined
      [label]="labelButtonCancel | translate"
      [disabled]="loading"
      [iconPosition]="false"
      (output)="onEventCancel()">
    </common-buttons-outlined>

    <common-buttons-filled
      [label]="labelButtonSave | translate"
      [disabled]="loading || selectedOptions.length === 0"
      [iconPosition]="false"
      (output)="onEventSave()">
    </common-buttons-filled>
  </mat-dialog-actions>
</div>
